import { observer } from 'mobx-react-lite'
import { useNavigate } from 'react-router-dom'
import styled from '@emotion/styled'
import { Typography } from '@mui/material'
import { useRussianPokerStore } from '../useRussianPokerStore'
import { yellow } from '../Notice'
import { RpDealerButton } from '../../../components'

const PopupExitButtons = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;
  gap: 20px;
`
const StyledPopupExit = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;
  gap: 50px;
  flex-direction: column;
`

const PopupExit = observer(() => {
  const { togglePopupExit } = useRussianPokerStore()
  const navigate = useNavigate()

  return (
    <StyledPopupExit>
      <Typography variant="h2" color={yellow}>
        Покинуть игру?
      </Typography>
      <PopupExitButtons>
        <RpDealerButton
          bg="green"
          text="Да"
          cb={() => {
            togglePopupExit()
            navigate('/')
          }}
        />
        <RpDealerButton
          bg="red"
          text="Нет"
          cb={() => {
            togglePopupExit()
          }}
        />
      </PopupExitButtons>
    </StyledPopupExit>
  )
})

export default PopupExit
